import { FC, useMemo } from "react";
import { useTranslation } from "next-i18next";

import { Modal, CloseIcon2 } from "@/components/Modal";
import EmptyImg from "@/public/img/points/empty.png";
import { ScrollView } from "@/components/UI/ScrollView";
import PointsRecordItem from "./record-item";
import { isMobile as checkIsMobile } from "@/utils/util";
import { formatThousand } from "@/utils/util";
import { useWindowHeight } from "@/hooks/useWindowHeight";

import { PointsBillInfo } from "@/types/points";

interface RecordModalProps {
  points: number;
  income: number | string;
  outcome: number | string;
  receipts: PointsBillInfo[];
  scale?: number;
  onClose: () => void;
}

const RecordModal: FC<RecordModalProps> = ({
  scale = 1,
  points,
  income,
  outcome,
  receipts,
  onClose,
}) => {
  const { t } = useTranslation("points");
  const isMobile = checkIsMobile();

  const { windowHeight } = useWindowHeight();

  console.log("RecordModal", { receipts }, "windowHeight", windowHeight);
  const isEmpty = useMemo(() => {
    return !receipts?.length;
  }, [receipts]);

  const modalStyle = useMemo(() => {
    return {
      backgroundColor: "transparent",
      "--tw-scale-x": scale,
      "--tw-scale-y": scale,
    };
  }, [scale]);
  return (
    <Modal
      style={modalStyle}
      closeIcon={<CloseIcon2 className="translate-y-[-4px]" />}
      onClose={onClose}
    >
      <div
        className="flex flex-col bg-white rounded-[40px] overflow-hidden max-h-[798px]"
        style={{
          maxHeight: Math.min(windowHeight / scale - 100, 798),
          minHeight: Math.min(windowHeight / scale - 100, 798),
        }}
      >
        <div className="flex items-center justify-center py-[24px] text-[24px] leading-[32px] font-bold font-DIN_Alternate">
          {t("record-modal-tit").toUpperCase()}
        </div>
        <div className="flex-1 flex flex-col pl-[56px] pr-[24px] pb-[60px] text-white border-0 border-t-[1px] border-solid border-[#000] overflow-hidden">
          <div className="relative flex-1 flex flex-col overflow-hidden">
            <div className="absolute bottom-[-2px] right-[10px] w-full h-[26px] bg-gradient-to-b from-[rgba(255,255,255,0)] to-white"></div>
            <ScrollView className="flex-1 py-[24px] pr-[32px] overflow-auto">
              <div className="flex flex-col pt-[24px] w-[400px] text-center bg-black rounded-[24px]">
                <div className="flex items-center justify-center">
                  <span>{t("points-current")}</span>
                </div>
                <h1 className="m-0 mt-[8px] font-black text-[40px] leading-[47px]">
                  {formatThousand(points)}
                </h1>
                <div className="flex items-center mt-[27px] text-[14px] leading-[16px] font-normal border-0 border-t-[1px] border-solid border-white">
                  <div className="flex-1 py-[12px]">
                    {t("points-income")}{" "}
                    <span className="font-bold">{formatThousand(income)}</span>
                  </div>
                  <div className="flex-1 py-[12px] border-0 border-l-[1px] border-solid border-white">
                    {t("points-outcome")}{" "}
                    <span className="font-bold">{formatThousand(outcome)}</span>
                  </div>
                </div>
              </div>
              {isEmpty ? (
                <div
                  className="mt-[25%] w-[400px] h-[174px] bg-cover"
                  style={{ backgroundImage: `url(${EmptyImg.src})` }}
                ></div>
              ) : (
                <>
                  <p className="m-0 mt-[24px] h-[1px] bg-[#e3e5e7] scale-y-50"></p>
                  <div className="pt-[24px] w-[400px]">
                    <p className="m-0 text-[22px] leading-[32px] font-bold text-black font-DIN_Alternate">
                      {t("receipt-tit")}
                    </p>
                    <ol className="p-0">
                      {receipts.map((item, idx: number) => (
                        <li
                          key={idx}
                          className="border-0 border-b-[0.5px] border-[#e3e5e7] border-solid"
                        >
                          <PointsRecordItem info={item} isMobile={isMobile} />
                        </li>
                      ))}
                    </ol>
                  </div>
                  <p className="mt-[32px] text-[12px] leading-[14px] text-center text-[#c9ccd0] font-thin">
                    — No more —
                  </p>
                </>
              )}
            </ScrollView>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RecordModal;
